import { configureStore } from "@reduxjs/toolkit";

import loginReducer from "../features/login/slice";
import sidebarReducer from "../components/sidebarSlice";
import accountReducer from "../features/account/accountSlice";
import favoritesReducer from "./slices/favorites";
import recommendationsReducer from "../features/recommendations/slice";
import usersReducer from "../features/users/slice";
import jobsReducer from "./slices/jobs";
import companyReducer from "./slices/company";
import thirdPartyReducer from "./slices/thirdParty";

export default configureStore({
  reducer: {
    login: loginReducer,
    sidebar: sidebarReducer,
    account: accountReducer,
    favorites: favoritesReducer,
    recommendations: recommendationsReducer,
    users: usersReducer,
    jobs: jobsReducer,
    company: companyReducer,
    thirdParty: thirdPartyReducer,
  },
});
